import React from 'react'
import {Badge, Box, Typography} from '@material-ui/core';
import GridBlock from 'components/GridBlock';
import clsx from 'clsx';
import WorkableIconExpandButton from "components/button/WorkableIconExpandButton";
import {makeStyles} from "@material-ui/styles";
import MailIcon from "@material-ui/icons/Mail";

const useStyle = makeStyles(theme => ({
    root: {
        '&>*:nth-child(2)': {
            flexGrow: 1,
        }
    },
    title: {
        marginLeft: theme.spacing()
    },
    rotate: {
        transform: 'rotate(180deg)'
    },
    cursorPointer: {
        cursor: 'pointer'
    }
}))

function OpinionElementTitle(
    {
        index,
        opinion,
        open,
        onOpen,
        coordinatorView,
    }) {

    const classes = useStyle();

    return (
        <GridBlock
            alignItems='center'
            className={classes.root}
            wrap='nowrap'
        >
            { coordinatorView ? <Typography></Typography> :
            <Typography
                variant='body1'
                className={classes.title}
            >
                {index + 1}.
            </Typography>
            }


            <Typography
                variant='body1'
                className={clsx(classes.cursorPointer, classes.title)}
                onClick={onOpen}
            >
                <Box
                    component='span'
                    fontWeight='fontWeightBold'

                >
                    {opinion.memberName}
                </Box>
            </Typography>

            {!coordinatorView && !!opinion.unreadCount && <Badge badgeContent={opinion.unreadCount} max={9} color="error">
                <MailIcon color='primary' onClick={onOpen}/>
            </Badge>}
            {!coordinatorView && <WorkableIconExpandButton
                color='primary'
                onClick={onOpen}
                expanded={open}
            />}
        </GridBlock>
    )
}

OpinionElementTitle.propTypes = {}

export default OpinionElementTitle;